module.exports = __webpack_public_path__ + "img/accident2SYJ.aa7afb2f.png";